import { useEffect, useState } from 'react';
import { Platform, Pressable, Text, View } from 'react-native';
import { LOJA_ANDROID, LOJA_IOS } from '../lib/config';
import { infoConvite } from '../lib/grupos';
import { C, aba } from './theme';
import { Btn } from './ui';
import type { AbaId } from '../store/types';
import { t } from '../lib/i18n';

/** Página aberta pelo link do convite, antes de entrar na conta: mostra o grupo, abre o app ou leva ao download. */
export function ConvitePublico({ codigo, onContinuar }: { codigo: string; onContinuar: () => void }) {
  const [info, setInfo] = useState<{ nome: string; aba: AbaId; membros: number } | null | undefined>(undefined);
  useEffect(() => {
    infoConvite(codigo).then(setInfo).catch(() => setInfo(null));
  }, [codigo]);
  const celular = Platform.OS === 'web' && typeof navigator !== 'undefined' && /android|iphone|ipad/i.test(navigator.userAgent);
  const iphone = Platform.OS === 'web' && typeof navigator !== 'undefined' && /iphone|ipad/i.test(navigator.userAgent);
  return (
    <View style={{ flex: 1, backgroundColor: C.bg, justifyContent: 'center', padding: 28, gap: 14 }}>
      <Text style={{ fontSize: 52, textAlign: 'center' }}>{info ? aba(info.aba)?.icon ?? '👥' : '📅'}</Text>
      <Text style={{ color: C.sub, textAlign: 'center' }}>{t('Convite para o My Planner')}</Text>
      {info ? (<>
        <Text style={{ color: C.text, fontSize: 24, fontWeight: '800', textAlign: 'center' }}>{info.nome}</Text>
        <Text style={{ color: C.sub, textAlign: 'center' }}>{[aba(info.aba)?.nome, t('{n} pessoa(s)', { n: info.membros })].filter(Boolean).join(' · ')}</Text>
      </>) : info === null ? <Text style={{ color: C.warn, textAlign: 'center' }}>{t('Convite inválido ou trocado pelo administrador. Peça um link novo.')}</Text> : null}
      <Text style={{ color: C.sub, fontSize: 13, textAlign: 'center' }}>{t('1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).')}</Text>
      <Text style={{ color: C.text, fontSize: 22, fontWeight: '800', letterSpacing: 3, textAlign: 'center' }} selectable>{codigo}</Text>
      {celular && <Btn cor="#8B5CF6" label={t('Já tenho o app: abrir o convite nele')} onPress={() => { window.location.href = `myplanner://convite?c=${codigo}`; }} />}
      {!iphone && <Btn cor="#8B5CF6" outline={celular} label={'📲 ' + t('Baixar o app')} onPress={() => { window.location.href = LOJA_ANDROID; }} />}
      {iphone && <Btn cor="#8B5CF6" outline={celular} label={'📲 ' + t('Baixar o app')} onPress={() => { window.location.href = LOJA_IOS; }} />}
      <Pressable onPress={onContinuar} style={{ alignItems: 'center', padding: 10 }}><Text style={{ color: '#8B5CF6', fontWeight: '700' }}>{t('Ir para o My Planner Web')}</Text></Pressable>
    </View>
  );
}
